export const DEFAULT_BAD_LEAFLETS = [
  {
    id: "bad_1",
    title: "الصدفية ومخاطرها على الصحة العامة",
    link: "",
    description: `ما هي الصدفية؟
الصدفية هي حالة جلدية مناعية مزمنة تسبب ظهور بقع حمراء ومتقشرة ومثيرة للحك، غالباً في المرفقين والركبتين وفروة الرأس والظهر. لا تعد الصدفية مرضاً معدياً على الإطلاق ولا تنتقل بالملامسة.

المخاطر على الصحة العامة:
الصدفية ليست مجرد مرض جلدي سطحي؛ فالالتهاب المناعي قد يرتبط بحالات طبية أخرى مثل التهاب المفاصل الصدفي، وأمراض القلب والأوعية الدموية، وارتفاع ضغط الدم، والسكري، لذا فإن المتابعة الطبية الشاملة والدورية تكتسي أهمية بالغة.

نصائح العناية والتحكم من الجمعية البريطانية لأطباء الجلدية (BAD):
• الالتزام المطلق بالمرطبات الطبية اليومية (المطريات) لتقليل الجفاف والحكة وتقوية حاجز الجلد.
• تجنب المهيجات الشهيرة مثل التوتر النفسي الشديد، التدخين، والإصابات الجلدية.
• اتباع خطة العلاج الموصوفة بدقة، والتي قد تشمل العلاجات الموضعية، العلاج الضوئي الطفي (UVB)، أو العلاجات البيولوجية الحديثة تحت إشراف الطبيب المختص.`,
    imageUrl: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "bad_2",
    title: "حب الشباب ومظهرك",
    link: "",
    description: `ما هو حب الشباب؟
هو اضطراب جلدي شائع ينشأ عندما تسد بصيلات الشعر بالزيوت (الزهم) وخلايا الجلد الميتة، مما يؤدي إلى ظهور البثور والرؤوس البيضاء والسوداء، خاصة على الوجه والصدر والظهر.

مفاهيم خاطئة يجب تصحیحها:
حب الشباب لا ينتج عن قلة النظافة، كما أن غسل الوجه بشكل مفرط أو فرك الجلد بعنف قد يضر البشرة ويزيد من شدة الالتهاب.

الروتين الطبي السليم والإرشادات:
• غسل الوجه بلطف مرتين يومياً بغسول طبي ملائم للبشرة الدهنية أو المعرضة للحبوب (Oil-Free / Non-comedogenic).
• تجنب عبث أو عصر الحبوب نهائياً لمنع انتقال البكتيريا ولتجنب تكون الندبات والتصبغات الدائمة.
• الالتزام بالعلاجات الموضعية (مثل مشتقات فيتامين أ والبنزيول بيروكسيد) أو العلاجات الفموية المقررة من طبيب الجلدية لعلاج الأسباب الجذرية واستعادة نضارة البشرة.`,
    imageUrl: "https://images.unsplash.com/photo-1617897903246-719242758050?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "bad_3",
    title: "الزوائد اللحمية والآفات الجلدية الحميدة",
    link: "",
    description: `ما هي الزوائد الجلدية؟
هي نمو جلدي صغير وحميد وغير مؤذٍ يميل للظهور في مناطق الاحتكاك مثل الرقبة، والإبطين، وثنايا الجلد، وجفون العين. وتزداد شيوعاً مع تقدم العمر أو مع الاحتكاك المستمر للملابس.

طرق العلاج والإزالة السهلة والسريعة:
• الزوائد الجلدية آمنة تماماً ولا تتحول لأورام خبيثة، ولكن يتم إزالتها لدواعي تجميلية أو لتجنب التهيج والألم الراجع للاحتكاك بالمجوهرات أو الأقمشة.
• يتم إزالتها بسهولة بالغة وبدون ألم داخل العيادة عبر الكي بالتبريد (النيتروجين السائل)، أو الكي الكهربائي الدقيق، أو التردد الحراري/الليزر دون الحاجة لجراحة أو غرز، ودون ترك آثار مزعجة.`,
    imageUrl: "https://images.unsplash.com/photo-1511174511562-5f7f18bf2764?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "bad_4",
    title: "التهاب الجلد التأتبي (الأكزيما التأتبية)",
    link: "",
    description: `ما هي الأكزيما التأتبية؟
مرض جلدي التهابي مزمن يسبب الجفاف والحكة الشديدة والاحمرار. يكثر ظهوره عند الأطفال وقد يستمر حتى البلوغ، ويرتبط غالباً بالتاريخ العائلي للتحسس والربو.

إرشادات العناية اليومية والتحكم بالنوبات:
• الترطيب المكثف: يعتبر الترطيب المستمر بمطريات الجلد الطبية الخالية من العطور أساس العلاج، ويجب تطبيقها بسخاء عدة مرات يومياً ومباشرة بعد الاستحمام.
• تنب المهيجات: تجنب الاستحمام بالماء شديد السخونة، وارتداء الملابس القطنية الناعمة والابتعاد عن الصوف والألياف الصناعية الملامسة للجلد.
• استخدام العلاجات الطبية: استخدام كريمات الكورتيزون الموضعية أو بدائل الكورتيزون المناعية بأمان عند تهج النوبات بالجرعة والمده المقررة من طبيبك المختص.`,
    imageUrl: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "bad_5",
    title: "البهاق (Vitiligo) ودليل الرعاية الحديثة",
    link: "",
    description: `ما هو البهاق؟
حالة مناعية ذاتية غير معدية يقوم فيها جهاز المناعة بمهاجمة وتدمير الخلايا الصبغية (الميلانين) في أجزاء معينة من الجلد، مما يؤدي لظهور بقع بيضاء ناصعة خالية من الصبغة.

خطوات العناية الفضلى والحماية:
• الحماية الصارمة من الشمس: الجلد الفاقد للصبغة لا يمتلك حماية طبيعية من الأشعة الفوق بنفسجية، لذا من الضروري تطبيق واقي شمس ذي حماية واسعة (SPF 50+) يومياً لتجنب الحروق وللحد من التباين اللوني.
• الراحة النفسية: العامل النفسي يتفاعل بوضوح مع الأمراض المناعية، لذا فإن الدعم النفسي والطمأنينة يعدان جزءاً مهماً من رحلة التشخيص والعلاج.
• خيارات العلاج المتطورة: تشمل العلاجات الضوئية الدقيقة (NARROWBAND UVB)، والكريمات المعدلة للمناعة الحدیثة التي تساعد في تحفيز الخلايا الصبغية لعودة اللون الطبيعي.`,
    imageUrl: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "bad_6",
    title: "داء الثعلبة وتساقط الشعر البقعي",
    link: "",
    description: `ما هي الثعلبة؟
تساقط بقعي ومفاجئ للشعر في فروة الرأس أو الذقن أو الحواجب، يحدث بسبب تفاعل مناعي عابر يستهدف بصيلات الشعر مؤقتاً دون أن يدمر الجذور نهائياً.

الخلفية السريرية وخيارات الاستجابة:
• في حالات كثيرة ومبكرة، يمكن للبصيلات أن تستعيد نشاطها ويعاود الشعر النمو تلقائياً عند انتظام التوازن المناعي.
• الخطط العلاجية المتطورة بالعيادة تتراوح بين تطبيق المحفزات الموضعية، أدوية تهدئة المناعة الموضعية، والحقن الموضعي الدقيق للفيتامينات ومضادات الالتهاب، وصولاً للعلاجات الموجهة للحالات الأكثر امتداداً.`,
    imageUrl: "https://images.unsplash.com/photo-1606902965551-dce093cda6e7?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "bad_7",
    title: "الكلف وتصبغات البشرة (Melasma)",
    link: "",
    description: `ما هو الكلف؟
ظهور بقع وتصبغات داكنة ومتماثلة غالباً على الوجنتين، الجبهة، والأنف. ويرتبط ظهور الكلف بشكل وثيق بالتغيرات الهرمونية، الحمل (كلف الحمل)، والتعرض التراكمي لأشعة الشمس والحرارة.

بروتوكولات العناية والتفتيح السريري:
• الحجر الأساس في السيطرة على الكلف هو الالتزام الصارم والدوري بواقي الشمس الواسع الطيف وتجديده كل ساعتين عند التعرض المباشر للشمس أو الإضاءة القوية.
• تجنب التعرض للحرارة المباشرة (مثل أبخرة الطهي عالية الحرارة).
• الاعتماد على البروتوكولات العلاجية الآمنة التي يحددها الطبيب (كالكريمات الثلاثية الموصوفة والتقشير الطبي المدروس) وتجنب المنتجات مجهولة المصدر التي قد تزيد التصبغات عمقا.`,
    imageUrl: "https://images.unsplash.com/photo-1511174511562-5f7f18bf2764?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "bad_8",
    title: "الوردية (Rosacea) وإدارة احمرار الوجه",
    link: "",
    description: `ما هي الوردية؟
حالة جلدية تؤدي إلى احمرار مزمن في وسط الوجه، مع بروز لشعيرات دموية دقيقة، وأحياناً ظهور بثرات صغيرة تشبه حب الشباب ولكن دون وجود الرؤوس السوداء أو البيضاء.

كيفية تحديد المهيجات والوقاية:
• تجنب المحفزات اليومية الشهيرة التي تؤدي إلى تمدد الأوعية الدموية وتوهج الوجه، مثل: التعرض العنيف للشمس، المشروبات شديدة السخونة، الأطعمة الغنية بالتوابل والفلفل الحار، والمجهود الرياضي المفرط في جو حار.
• الاعتماد التام على المستحلبات والمنتجات فائقة اللطف والمخصصة للبشرة الحساسة والمصابة بالوردية، واتباع توجيهات الطبيب في استخدام الكريمات المقبضة للأوعية أو جلسات الليزر الوعائي.`,
    imageUrl: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "bad_9",
    title: "الجرب والعدوى الطفيلية (Scabies)",
    link: "",
    description: `ما هو الجرب الجلدي؟
عدوى جلدية تسببها طفيليات مجهرية تنتقل بالتلامس الجلسي المباشر أو عبر الملابس والأغطية المشتركة. العرض الأساسي هو الحكة الشديدة والمزعجة التي تزداد وطأتها بشكل خاص خلال الليل وعند التدفئة في الفراش.

إرشادات القضاء التام على العدوى (تعليمات BAD الذهبية):
• العلاج الجماعي: يجب أن يتم علاج الشخص المصاب وجميع أفراد الأسرة أو المقيمين في نفس المنزل في نفس اليوم وبوقت متزامن حتى لو لم يعانوا من الحكة بعد.
• التطبيق الصحيح: تطبيق المستحلب الطبي الموصوف من تحت الرقبة حتى كامل أصابع وأطافر القدمين، وبقاؤه للمدة المطلوبة بالتحديد دون غسله.
• غسل وتعقيم الملابس ومفارش سرير المرض وتجفيفها بالحرارة العالية لقطع دابر دورة حياة الطفيلي نهائياً.`,
    imageUrl: "https://images.unsplash.com/photo-1617897903246-719242758050?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "bad_10",
    title: "الشرية المترددة والحساسية الجلدية (Urticaria)",
    link: "",
    description: `ما هي الشرية؟
ظهور طفح جلدي مفاجئ مسبب للحكة الشديدة على شكل بقع حمراء أو وردية منتفخة (تشبه لسعات النحل أو نبتة القריص)، تتميز بأن البقعة قد تختفي في غضون ساعات لتظهر في منطقة أخرى من الجسم.

إرشادات التحكم والتعامل السليم:
• تجنب حك الجلد بشدة باليد، حيث أن الاحتكاك يستثير الخلايا لإفراز المزيد من مادة (الهيستامين) المسببة للحكة والتورم.
• اللجوء إلى الكمادات الباردة واللطيفة لتهدئة تهيج الجلد وتجنب الاستحمام بالماء الساخن.
• يعتمد العلاج الفعال والآمن على الانتظام في تناول مضادات الهيستامين الحديثة والمنظمة التي يحددها لك الطبيب المختص لضبط نشاط الخلايا التحسسية والوقاية من تكرار النوبات.`,
    imageUrl: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&q=80&w=800"
  }
];
